import service from "./service";

/** GET /notifications/settings — the signed-in user's own preferences. */
const getSettings = async () => {
  return service.get("/notifications/settings").then((response) => {
    return response;
  });
};

/**
 * PATCH /notifications/settings — partial, so only the toggles that changed
 * need to be sent.
 * @param {object} payload any subset of the settings flags
 */
const updateSettings = async (payload) => {
  return service.patch("/notifications/settings", payload).then((response) => {
    return response;
  });
};

/**
 * GET /notifications - the bell's feed, newest first and cursor-paginated.
 * @param {{ cursor?: string, limit?: number }} params
 */
const getFeed = async ({ cursor, limit = 10, assistantId } = {}) => {
  // Only sent when there is one: an empty assistantId would scope the feed to
  // nothing rather than to everything.
  const params = { limit };
  if (cursor) params.cursor = cursor;
  if (assistantId) params.assistantId = assistantId;

  return service.get("/notifications", { params }).then((response) => {
    return response;
  });
};

/** GET /notifications/unread-count - the badge number. */
// Scoped the same way as the feed, so the badge counts what the panel will
// actually show rather than every assistant on the account.
const getUnreadCount = async ({ assistantId } = {}) => {
  const params = assistantId ? { assistantId } : {};

  return service
    .get("/notifications/unread-count", { params })
    .then((response) => {
      return response;
    });
};

/** PATCH /notifications/:id/read - a no-op 200 if it was already read. */
const markRead = async (id) => {
  return service.patch(`/notifications/${id}/read`, {}).then((response) => {
    return response;
  });
};

/** POST /notifications/read-all */
const markAllRead = async () => {
  return service.post("/notifications/read-all", {}).then((response) => {
    return response;
  });
};

const notificationsService = {
  getSettings,
  updateSettings,
  getFeed,
  getUnreadCount,
  markRead,
  markAllRead,
};

export default notificationsService;
